module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    key: _vm.item.id,
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.item)
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    attrs: {
      "title": _vm.transport
    }
  }, [_vm._v(_vm._s(_vm.transport))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-sub-title', [_c('strong', [_vm._v("to:")]), _vm._v(" "), _vm._l((_vm.item.recipient_emails), function(recipient) {
    return (_vm.transport === "email") ? [_c('v-chip', {
      key: recipient,
      staticClass: "v-chip--x-small",
      attrs: {
        "label": "",
        "small": "",
        "outline": "",
        "color": "primary"
      }
    }, [_vm._v(_vm._s(recipient))])] : _vm._e()
  }), _vm._v(" "), (_vm.transport === "sms" && _vm.item.recipient_phone_number) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "small": "",
      "outline": "",
      "label": "",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.recipient_phone_number))]) : _vm._e()], 2), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "caption",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "caption"
  }, [_c('strong', [_vm._v("Sent: " + _vm._s(_vm.dateformat(_vm.item.created_date, 'ddd DD MMM YYYY H:mma')) + " via " + _vm._s(_vm.transport))])])], 1), _vm._v(" "), (_vm.item.communicationstatus && _vm.item.communicationstatus.length > 0) ? _c('v-list-tile-action', {
    staticClass: "hidden-xs-only"
  }, [_c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "flat": "",
            "small": ""
          },
          slot: "activator"
        }, on), [_vm._v("\n        " + _vm._s(_vm.item.communicationstatus[_vm.item.communicationstatus.length - 1].status) + "\n        "), _c('v-icon', [_vm._v("expand_more")])], 1)]
      }
    }], null, false, 295767040)
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.item.communicationstatus), function(status) {
    return _c('v-list-tile', {
      key: status.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(status.status.toLowerCase()))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.dateformat(status.created_date, 'ddd DD MMM YYYY H:mm a')))])], 1)], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6e58c2a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listitems/CommunicationListItem.vue
// module id = 1541
// module chunks = 9